import { render, staticRenderFns } from "./ThgBatchDetailInformationChangeHistoryCard.vue?vue&type=template&id=6a456bb0&"
import script from "./ThgBatchDetailInformationChangeHistoryCard.vue?vue&type=script&lang=ts&"
export * from "./ThgBatchDetailInformationChangeHistoryCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VCol,VIcon,VRow,VTimeline,VTimelineItem})
